export default __webpack_public_path__ + "locales/az/PDFFormDialog.json?hash=e3f1f4b1a400700690f0a10ba5fd0807";